// extracted by mini-css-extract-plugin
module.exports = {"editAvatar":"editAvatar_editAvatar__DrWh9","avatarBox":"editAvatar_avatarBox__Sgr2Y","avatar":"editAvatar_avatar__J7rdD","edit":"editAvatar_edit__N3gzh"};